import OrderListCentral from "./CentralOrderComponent";

const CentralOppsModuleComponent = () => {
  return (
    <>
      <OrderListCentral />
    </>
  );
};

export default CentralOppsModuleComponent;
